import Axios from "axios";
import {store} from '../../store/';

export const DisplaySetting = {
  saveDisplaySettings(data) {
    return Axios.patch(`/hospitals/${store.state.user.active_user.ref}/display_settings/${data.id}`, {display_setting: data})
  },
};